import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router";
import { ory } from "../../utils/ory";

const AuthGuard = () => {
  const [isValidSession, setIsValidSession] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchSession = async () => {
      try {
        const { data } = await ory.toSession();
        setIsValidSession(data.active ?? false);
      } catch (error) {
        navigate("/", { replace: true });
      }
    };

    fetchSession();
  }, []);

  if (!isValidSession) {
    return null;
  }

  return <Outlet />;
};

export default AuthGuard;
